import { AnyAction } from 'redux';
import { FETCH_CONTENT_SUCCESS } from 'redux/actions/contentful';
import { ContentfulState } from './ContentfulState';

const initialState: ContentfulState = {
	AGB_keh_mobile: '',
	AGB_keh: '',
	AGB_kpe_mobile: '',
	AGB_kpe: '',
	AGB_kpp_mobile: '',
	AGB_kpp: '',
	AGB_postbox_mobile: '',
	AGB_postbox: '',
	agreement: '',
	agreement2: '',
	agreement3: '',
	agreement4: '',
	agreementKeh1: '',
	faqContent: { entries: [] },
	GDPR_kpe_mobile: '',
	GDPR_kpe: '',
	GDPR_kpp_mobile: '',
	GDPR_kpp: '',
	GDPR_mobile: '',
	GDPR: '',
	imprint_mobile: '',
	imprint: '',
	IPID_keh_mobile: '',
	IPID_keh: '',
	IPID_kpe_mobile: '',
	IPID_kpe: '',
	IPID_kpp_mobile: '',
	IPID_kpp: '',
	privacy_policy_mobile: '',
	privacy_policy: '',
	privacy_bank11_policy_mobile: '',
	privacy_bank11_policy: '',
	quickMenuExplainVideoUrl: '',
	title: '',
	ipid_epm:'',
	ipid_eppm:'',
	ipid_epe:'',
	ipid_eph:'',
	ipid_epp:'',
	ipid_epph:'',
	agb_epm:'',
	agb_eppm:'',
	agb_epe:'',
	agb_eph:'',
	agb_epp:'',
	agb_epph:'',
	gdpr_ep:'',
	gdpr_epp:'',
	agb_postbox_neutral: '',
};

export function contentfulReducer(
	state: ContentfulState = initialState,
	action: AnyAction
): ContentfulState {
	switch (action.type) {
		case FETCH_CONTENT_SUCCESS:
			return {
				...state,
				...action.payload,
			};
		default:
			return state;
	}
}
